import { z } from 'zod';
/**
 * Sortierung von Listen per Klick auf die Spaltenüberschrift. Der Parameter `sort` nennt eine Spalte, mit vorangestelltem „-“ absteigend, zum Beispiel
 * „createdAt“ oder „-gross“. Welche Spalten eine Liste anbietet, legt sie selbst fest. Sortiert wird immer auf dem Server, weil die Listen seitenweise geladen werden.
 */
export function sortParam(keys, fallback) {
    return z.enum([...keys, ...keys.map((k) => `-${k}`)]).default(fallback);
}
/** Zerlegt „-gross“ in Spalte und Richtung */
export function splitSort(sort) {
    return sort.startsWith('-') ? { key: sort.slice(1), desc: true } : { key: sort, desc: false };
}
//# sourceMappingURL=sort.js.map